import { type ReactNode, useMemo, useState } from 'react';
import { getWebPartition } from '@/helpers';
import { WEB_PARTITION } from '@/types';
import { PartitionContext } from './partitionContext';

type PartitionProviderProps = {
  children: ReactNode;
};

export const PartitionProvider = ({ children }: PartitionProviderProps) => {
  const [partition, setPartition] = useState<WEB_PARTITION>(() => getWebPartition(window.location.pathname));

  const value = useMemo(
    () => ({
      partition,
      setPartition,
    }),
    [partition]
  );

  return <PartitionContext.Provider value={value}>{children}</PartitionContext.Provider>;
};
